import { Control, Controller, useWatch } from 'react-hook-form';
import { SelectItem, TmdxSelect, TmdxSwitch } from '@ds';
import { CaseFormType } from '@features/forms/CaseForms/schema';
import { FormRow } from '@features/components/CaseFormBlocks/components';
import { NRP_TYPES } from '@features/components/CaseFormBlocks/config';
import { DonorType, NRPOption } from '@/api/apis/case';

export const NrpSelector = ({ control, disable }: { control: Control<CaseFormType>; disable?: boolean }) => {
  const nrp = useWatch({ control, name: 'nrp' });
  const donorType = useWatch({ control, name: 'donorType' });
  if (donorType === DonorType.DBD) return null;

  return (
    <>
      <FormRow title="NRP">
        <Controller
          name="nrp"
          control={control}
          render={({ field: { ref, ...field } }) => (
            <div className="flex items-center gap-3 text-l-m h-10">
              <span>No</span>
              <TmdxSwitch
                isDisabled={disable}
                isSelected={field.value === NRPOption.Yes}
                color="default"
                size="sm"
                onValueChange={(checked) => field.onChange(checked ? NRPOption.Yes : NRPOption.No)}
              />
              <span>Yes</span>
            </div>
          )}
        />
      </FormRow>
      {nrp === NRPOption.Yes && (
        <FormRow title="NRP Type">
          <div className="grow-0 flex-[48.5%]">
            <Controller
              name="nrpType"
              control={control}
              render={({ field: { value, ...field }, fieldState: { invalid, error } }) => (
                <TmdxSelect
                  isDisabled={disable}
                  placeholder="Not Selected"
                  aria-label="Select nrp type"
                  selectedKeys={value ? [value] : undefined}
                  isInvalid={invalid}
                  errorMessage={error?.message}
                  disallowEmptySelection
                  {...field}
                >
                  {NRP_TYPES.map((option) => (
                    <SelectItem key={option.value}>{option.name}</SelectItem>
                  ))}
                </TmdxSelect>
              )}
            />
          </div>
        </FormRow>
      )}
    </>
  );
};
